var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-task',[_c('lab-analysis-of-iron',{attrs:{"unknowns":_vm.unknowns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }